import React from "react";
import ModalShell from "./modalShell";
import { showValidationError } from "../../../components/onboarding/apiHelper";

const MarginManagementModal = ({ data, handleMarginManagementChange, isOpen, handleModalClose }) => {
    if (!isOpen) return null;

    const handleSaveChanges = () => {
        const missing = data.margin_management.filter(product => product.margin === undefined || product.margin === '');
        if (missing.length) {
            showValidationError(
                'Please enter a margin for every product.',
                missing.map(product => product.name),
            );
            return;
        }
        const missingRevenueCap = data.margin_management.filter(
            product => product.isRevenue && (product.revenueCap === undefined || product.revenueCap === '')
        );
        if (missingRevenueCap.length) {
            showValidationError(
                'Please enter a revenue cap for every product it is switched on for.',
                missingRevenueCap.map(product => product.name),
            );
            return;
        }
        handleModalClose();
    };
    return (
        <ModalShell
            title="Margin Management"
            subtitle="Enter the margin, and a revenue cap where it applies"
            onClose={handleModalClose}
        >
                    {/* no top padding here — the sticky header owns it, so nothing can
                        scroll into view above it */}
                    <div className="rize-modal-form profile-review-scrollbar flex-1 overflow-y-auto overscroll-contain px-5 sm:px-8">
                        <div className="mx-auto w-full max-w-3xl mb-8">
                            {/* Column headers — stay in view while the list scrolls */}
                            <div className="sticky top-0 z-10 grid grid-cols-12 gap-4 border-b border-slate-200 bg-white/95 pb-3 pt-6 backdrop-blur">
                                <div className="col-span-4 text-sm font-semibold text-slate-700">Product</div>
                                <div className="col-span-3 text-sm font-semibold text-slate-700">Margin</div>
                                <div className="col-span-5 text-sm font-semibold text-slate-700">Revenue Caps</div>
                            </div>

                            <div className="divide-y divide-slate-100">
                                {data.margin_management.map((product, index) => (
                                    <div key={index} className="grid grid-cols-12 items-center gap-4 py-3 transition-colors hover:bg-[#fff8f3]">
                                        <div className="col-span-4 text-sm text-slate-700">
                                            {product.name}
                                        </div>
                                        <div className="col-span-3 flex items-center gap-1">
                                            <span className="text-slate-500 shrink-0">%</span>
                                            <input
                                                min="0"
                                                type="number"
                                                step="0.00001"
                                                className="number-input block h-10 w-full rounded-lg border border-slate-300 p-2 text-sm shadow-sm focus:border-orange-400 focus:ring-orange-400"
                                                value={product.margin}
                                                onChange={(e) => {
                                                    let rawValue = e.target.value;
                                                    if (rawValue.match(/^\d*\.?\d*$/)) {
                                                        handleMarginManagementChange(index, 'margin', rawValue);
                                                    }
                                                }}
                                                onFocus={(e) => {
                                                    if (e.target.value === "0") e.target.value = "";
                                                }}
                                                onBlur={(e) => {
                                                    let value = parseFloat(e.target.value);
                                                    value = isNaN(value) ? '' : value;
                                                    handleMarginManagementChange(index, 'margin', value.toString());
                                                }}
                                            />
                                        </div>
                                        <div className="col-span-5 flex items-center gap-2">
                                            <label htmlFor={product.name} className="cursor-pointer shrink-0">
                                                <div className="relative">
                                                    <input
                                                        id={product.name}
                                                        type="checkbox"
                                                        className="sr-only"
                                                        checked={product.isRevenue || false}
                                                        onChange={() => handleMarginManagementChange(index, 'isRevenue', !product.isRevenue)}
                                                        tabIndex="-1"
                                                    />
                                                    <div className={`block ${product.isRevenue ? 'bg-custom-orange' : 'bg-gray-600'} w-14 h-7 rounded-full`} />
                                                    <div
                                                        className={`dot absolute left-1 top-1 bg-white w-5 h-5 rounded-full transition ${product.isRevenue ? 'translate-x-6' : ''}`}
                                                    ></div>
                                                </div>
                                            </label>
                                            {product.isRevenue ? (
                                                <>
                                                    <span className="text-slate-500 shrink-0">$</span>
                                                    <input
                                                        type="text"
                                                        className="number-input block h-10 w-full rounded-lg border border-slate-300 p-2 text-sm shadow-sm focus:border-orange-400 focus:ring-orange-400"
                                                        value={product.revenueCap}
                                                        onFocus={(e) => {
                                                            if (e.target.value === "0") e.target.value = "";
                                                        }}
                                                        onChange={(e) => handleMarginManagementChange(index, 'revenueCap', e.target.value)}
                                                    />
                                                </>
                                            ) : (
                                                <span className="text-sm text-slate-500">No</span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='sticky bottom-0 z-20 -mx-5 flex flex-col-reverse justify-end gap-3 border-t border-slate-200 bg-white px-5 py-4 sm:-mx-8 sm:flex-row sm:px-8'>

                            <button
                                className="inline-flex h-11 w-full items-center justify-center rounded-xl border border-slate-300 bg-white px-5 text-sm font-semibold text-[#211b4f] hover:bg-slate-50 sm:w-auto"
                                type='button'
                                onClick={handleModalClose}
                            >
                                Cancel
                            </button>
                            <button
                                className="inline-flex h-11 w-full items-center justify-center rounded-xl bg-[#211b4f] px-6 text-sm font-semibold text-white shadow-sm hover:bg-[#30266c] sm:w-auto"
                                type='button'
                                onClick={handleSaveChanges}
                            >
                                Save Changes
                            </button>

                        </div>
                    </div>
        </ModalShell>
    )
};

export default MarginManagementModal;
